import React from "react"

import { connect } from "react-redux"

import { withTranslation, useTranslation } from "react-i18next"

import ShopItemComponent from "./ShopItemComponent"
import { getActiveVehicle } from "../../../../helpers/vehicleHelpers"
import { MD_HD_VEHICLE_TYPE_ID } from "../../../../constants/application"

const ShopListViewItemComponent = (props) => {
  const { t } = useTranslation("dashboardMapComponent")

  let vehicleTypeId
  if (props.user) {
    const activeVehicle = getActiveVehicle()
    vehicleTypeId = (activeVehicle && activeVehicle.vehicle_type_id) || null
  }

  const height =
    vehicleTypeId && vehicleTypeId === MD_HD_VEHICLE_TYPE_ID && props.showMapExpanded
      ? Math.max(window.innerHeight * 0.65, 300) - 80
      : Math.max(window.innerHeight * 0.65, 300) - 20

  return (
    <div className="shopListView" style={{ height: height }}>
      {props.shops && props.shops.length > 0 ? (
        props.shops.map((shop, index) => (
          <ShopItemComponent
            showMapExpanded={true}
            key={index}
            onClose={props.onClose}
            shop={shop}
            onSelectShopClick={props.onSelectShopClick}
          />
        ))
      ) : (
        <div className={props.showMapExpanded ? "noShopFoundExpanded" : "noShopFound"}>
          <div className="shops-empty-state">{t("noShopFound")}</div>
        </div>
      )}
    </div>
  )
}

function mapStateToProps(state) {
  let user = state.user
  return { user: user }
}

export default connect(mapStateToProps)(
  withTranslation("dashboardMapComponent")(ShopListViewItemComponent)
)
